import * as React from "react";
import { IBaseKlantOndersteuningFormProps, ISubmitResult, ResponseMapper } from "@klantondersteuning-btl/shared";
import { FormBaseComponent } from "@cak-legacy/shared-generation-form-flow-overview";
import { ehicFormulierSchema, EhicFormulierSchemaModel } from "../schema/EhicFormulier";
import { KlantOndersteuningService } from "../service/klant-ondersteuning-service";
import { FormSubmitted } from "../component/form-submitted";

const defaultValues = {
  klantContactId: 0,
  persoonlijkDossier: {
    CAKIDnummer: "",
    geboorteDatum: ""
  },
  contactgegevens: {
    emailAdres: "",
    emailAdresControle: ""
  }
};

export interface IEhicFormulierContainerProps extends IBaseKlantOndersteuningFormProps {
  formulierKenmerk: string;
};

export const EhicFormulierContainer = (props: IEhicFormulierContainerProps) => {
  const service = new KlantOndersteuningService(props.apiUrl);
  const responseMapper = new ResponseMapper();
  
  const handleSubmit = (values: EhicFormulierSchemaModel) => service.ehicFormulier(values);
  const mapResponse = (response: ISubmitResult) => responseMapper.map(response);

  const handleReset = () => defaultValues;
  const renderFormSubmitted = (values: EhicFormulierSchemaModel) => <FormSubmitted {...props} values={values} />;

  return (
    <FormBaseComponent<EhicFormulierSchemaModel, ISubmitResult>
      introText={props.introText}
      introConfirmPageText={props.introConfirmPageText}
      getSchema={ehicFormulierSchema}
      pageBaseUrl={props.pageBaseUrl}
      handleSubmit={handleSubmit}
      mapResponse={mapResponse}
      handleReset={handleReset}
      defaultValues={defaultValues}
      renderFormSubmitted={renderFormSubmitted}
    />
  );
};

